



import React, { useEffect } from 'react';
import './About.css'

function About() {
    useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to the top of the page
    }, []);
    return (
        <div>

            <section class="boldSection bottomSemiSpaced btPageHeadline gutter  topSemiSpaced btTextLeft wBackground cover btParallax btDarkSkin btBackgroundOverlay btSolidDarkBackground "
                style={{ backgroundImage: `url(&quot;https://industrial.bold-themes.com/blue-laboratory/wp-content/uploads/sites/11/2016/09/hero_inner_page.jpg&quot;)`,marginLeft:"-30px", backgroundColor: "#142340", backgroundPosition: "50% 120.548px", dataParallax: "0.8", dataParallaxOoffset: "0" }}><div class="port"><header class="header btClear large"><div class="btSuperTitle"><span><div class="btBreadCrumbs"><nav className='abt1'><ul><li><a href="/">Home</a></li><li><a href="#">About</a></li></ul></nav></div></span></div><div class="dash"><h2><span class="headline abt2">  About us</span></h2></div><div class="btSubTitle abt3">
                    "Welcome to our about page, where we share the story behind our brand. Learn about our mission, values, and the people who drive our success. Discover what makes us unique."</div></header></div>
            </section>



            <section id="bt_section662752c981de6" class="boldSection topSemiSpaced gutter boxed inherit"><div class="port">
                <div class="boldCell"><div class="boldCellInner"><div class="boldRow btTableRow">
                    <div class="boldRowInner" style={{marginLeft:"-60px"}}>
                        <div class="rowItem col-md-6 col-sm-12 btTextLeft animate animate-fadein btMiddleVertical btDoublePadding animated" data-width="6">
                            <div class="rowItemContent">
                                <header class="header btClear large btDash bottomDash  ">
                                    <div class="dash abt4"><h2><span class="headline" style={{ color: "black" }}>About us</span>
                                    </h2>
                                    </div>

                                    <div class="btSubTitle abt5" style={{textAlign:"justify"}}> <b style={{ fontSize: "30px" }}>Automet Engineering </b><br />
                                        Welcome to Automet Engineering, your trusted partner in precision manufacturing solutions. Based in Bangalore, India, Automet Engineering specializes in the production of perforated plated sheets and hydraulic press components of various types </div></header>
                                <div class="btClear btSeparator topSmallSpaced bottomSmallSpaced noBorder"></div>
                                <div class="btText abt6" style={{textAlign:"justify" }}><p style={{fontSize:"19px"}}> At Automet Engineering, we work closely with our clients to ensure that our manufacturing processes align with their specific needs and timelines. Whether you're in need of perforated plated sheets, hydraulic press components, or custom solutions, Automet Engineering is dedicated to providing you with superior quality products and unparalleled customer service. Experience the Automet advantage today and discover why we are the preferred choice for precision manufacturing in Bangalore, India..</p>
                                </div><div class="btClear btSeparator topSmallSpaced bottomSmallSpaced noBorder"></div><div class="boldRow " style={{ maxWidth: '530px', float: 'right' }}><div class="boldRowInner"><div class="rowItem rowInnerItem col-sm-6  btTextLeft"><div class="rowItemContent"><div class="bpgPhoto out-right">
                                    <a href="#" target="_self" title=""></a>
                                    <div class="boldPhotoBox"><div class="bpbItem"><div class="btImage">
                                        <img decoding="async abt7" style={{ borderRadius: "20px" }} src="" alt="" title="" /></div></div></div>
                                    <div class="captionPane btDarkSkin btTextCenter">
                                        <div class="captionTable">
                                            <div class="captionCell">
                                                <div class="captionTxt"></div>
                                            </div>
                                        </div>
                                    </div></div><div class="btClear btSeparator bottomExtraSmallSpaced noBorder"></div><div class="btText"><p><small><em></em></small></p>
                                    </div></div></div><div class="rowItem rowInnerItem col-sm-6  btTextLeft"><div class="rowItemContent"><div class="bpgPhoto btDefaultHoverType out-left">
                                        <a href="#" target="_self" title=""></a>
                                        <div class="boldPhotoBox"><div class="bpbItem"><div class="btImage">
                                            <img decoding="async" style={{ borderRadius: "20px" }} src="" alt="" title="" /></div></div></div>
                                        <div class="captionPane btDarkSkin btTextCenter">
                                            <div class="captionTable">
                                                <div class="captionCell">
                                                    <div class="captionTxt"></div>
                                                </div>
                                            </div>
                                        </div></div><div class="btClear btSeparator bottomExtraSmallSpaced noBorder"></div><div class="btText"><p><small><em></em></small></p>
                                        </div></div></div></div></div><div class="btClear btSeparator topSemiSpaced noBorder"></div></div></div><div class="rowItem col-md-6 col-sm-12 btTextCenter animate animate-fadein inherit btNoPadding animated" data-width="6"><div class="rowItemContent"><div class="bpgPhoto btHasComplexContent out-left"><div class="btImage abt7"><img decoding="async abt7" style={{ borderRadius: "20px" }}
                                            src="https://industrial.bold-themes.com/blue-laboratory/wp-content/uploads/sites/11/2016/10/inner_large_2-1280x1280.jpg" alt="" title="" /></div></div><div class="btClear btSeparator bottomSemiSpaced noBorder"></div></div></div></div></div></div></div></div>
            </section>



            <section id="bt_section662752c982dd0" data-parallax="0.8" data-parallax-offset="0" class="boldSection topSpaced bottomSemiSpaced btDarkSkin btAlternateColorBackground gutter boxed inherit btParallax wBackground cover wBackground cover" style={{ backgroundimage: `url(&quot;https://industrial.bold-themes.com/blue-laboratory/wp-content/uploads/sites/11/2016/10/background_3.jpg&quot;)`, backgroundPosition: "50% -67.9002px" }}>
                <div class="port">
                    <div class="boldCell">
                        <div class="boldCellInner">

                            <div class="boldRow">
                                <div class="boldRowInner">


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section id="bt_section662752c98330d" className="boldSection topSemiSpaced btAlternateColorBackground gutter boxed inherit" style={{ backgroundColor: 'rgb(242,241,237) !important', marginTop: "-200px" }}>
                <div className="port">
                    <div className="boldCell">
                        <div className="boldCellInner">
                            <div className="boldRow">
                                <div className="boldRowInner">

                                    <div className="rowItem col-md-6 col-sm-12 btTextCenter animate animate-fadein inherit btNoPadding animated" data-width="6">
                                        <div className="rowItemContent">
                                            <div className="bpgPhoto out-left">
                                                <div className="btImage">
                                                    <img decoding="async" style={{ height: "440px", borderRadius: "20px" }} src="https://industrial.bold-themes.com/blue-laboratory/wp-content/uploads/sites/11/2016/10/inner_large_3-1280x1280.jpg" alt="" title="" />
                                                </div>
                                            </div>
                                            <div className="btClear btSeparator bottomSemiSpaced noBorder"></div>
                                        </div>
                                    </div>

                                    <div className="rowItem col-md-6 col-sm-12 btTextLeft animate animate-fadein inherit btDoublePadding animated" data-width="6">
                                        <div className="rowItemContent">
                                            <header className="header btClear large btDash bottomDash">
                                                <div className="dash">
                                                    <h2><span className="headline" style={{ color: "black" }}>Mission</span></h2>
                                                </div>
                                                <div className="btSubTitle" style={{textAlign:"justify"}}>The mission of our automet engineering manufacturing industry is to lead the way in transforming traditional manufacturing processes through automation. We are committed to leveraging advanced technologies to streamline operations, increase productivity, and deliver high-quality products efficiently. By embracing automation, we aim to drive innovation, reduce costs, and exceed customer expectations, all while fostering a culture of continuous improvement and sustainability. </div>
                                            </header>
                                            <div className="btClear btSeparator topSmallSpaced bottomSmallSpaced noBorder"></div>
                                            <div className="btText">
                                                <p></p>
                                            </div>
                                            <div className="btClear btSeparator bottomSemiSpaced noBorder"></div>
                                            <div className="boldRow" style={{ maxWidth: '530px' }}>
                                                <div className="boldRowInner">
                                                    <div className="rowItem rowInnerItem col-sm-6 btTextLeft inherit animate animate-fadein animated">
                                                        <div className="rowItemContent">

                                                            <div className="btClear btSeparator bottomSemiSpaced noBorder"></div>
                                                        </div>
                                                    </div>
                                                    <div className="rowItem rowInnerItem col-sm-6 btTextLeft inherit animate animate-fadein animated">
                                                        <div className="rowItemContent">

                                                            <div className="btClear btSeparator bottomSemiSpaced noBorder"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="btClear btSeparator topSemiSpaced noBorder"></div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <section id="bt_section662752c98330d" className="boldSection topSemiSpaced btAlternateColorBackground gutter boxed inherit" style={{ backgroundColor: 'rgb(242,241,237) !important', marginTop: "-200px" }}>
                <div className="port">
                    <div className="boldCell">
                        <div className="boldCellInner">
                            <div className="boldRow">
                                <div className="boldRowInner">

                                    <div className=" abt10 rowItem col-md-6 col-sm-12 btTextLeft animate animate-fadein inherit btDoublePadding animated" data-width="6">
                                        <div className="rowItemContent">
                                            <header className="header btClear large btDash bottomDash">
                                                <div className="dash">
                                                    <h2><span className="headline" style={{ color: "black" }}>Vision</span></h2>
                                                </div>
                                                <div className="btSubTitle" style={{textAlign:"justify"}}>At AutometEnigeering, our vision is to lead the future of manufacturing through relentless innovation and automation. We envision a world where precision engineering meets seamless efficiency, driving progress and shaping industries for generations to come. With our commitment to excellence and cutting-edge technology, we aim to redefine the possibilities of automated manufacturing, setting new standards of quality, reliability, and sustainability. </div>
                                            </header>
                                            <div className="btClear btSeparator topSmallSpaced bottomSmallSpaced noBorder"></div>
                                            <div className="btText">
                                                <p></p>
                                            </div>
                                            <div className="btClear btSeparator bottomSemiSpaced noBorder"></div>
                                            <div className="boldRow" style={{ maxWidth: '530px' }}>
                                                <div className="boldRowInner">
                                                    <div className="rowItem rowInnerItem col-sm-6 btTextLeft inherit animate animate-fadein animated">
                                                        <div className="rowItemContent">

                                                            <div className="btClear btSeparator bottomSemiSpaced noBorder"></div>
                                                        </div>
                                                    </div>
                                                    <div className="rowItem rowInnerItem col-sm-6 btTextLeft inherit animate animate-fadein animated">
                                                        <div className="rowItemContent">

                                                            <div className="btClear btSeparator bottomSemiSpaced noBorder"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="btClear btSeparator topSemiSpaced noBorder"></div>
                                        </div>
                                    </div>
                                    <div className="  rowItem col-md-6 col-sm-12 btTextCenter animate animate-fadein inherit btNoPadding animated" data-width="6">
                                        <div className="rowItemContent">
                                            <div className="bpgPhoto out-left ">
                                                <div className="btImage abt9 ">
                                                    <img decoding="async " style={{ height: "440px", borderRadius: "20px" }} src="https://industrial.bold-themes.com/blue-laboratory/wp-content/uploads/sites/11/2016/10/inner_large_3-1280x1280.jpg" alt="" title="" />
                                                </div>
                                            </div>
                                            <div className="btClear btSeparator bottomSemiSpaced noBorder"></div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* <section
                id="bt_section6627350a9cb85"
                className="boldSection topSmallSpaced btDarkSkin  gutter boxed inherit"
            >
                <div className="port">
                    <div className="boldCell">
                        <div className="boldCellInner">
                            <div className="boldRow btTableRow">
                                <div className="boldRowInner">
                                    <div
                                        className="rowItem col-md-8 col-ms-12 btTextLeft animate animate-fadein btMiddleVertical animated"
                                        data-width={8}
                                    >
                                        <div className="rowItemContent">
                                            <header className="header btClear small  ">
                                                <div className="dash">
                                                    <h4>
                                                        <span className="headline">
                                                            Looking for a First-Class Scientific Partner?
                                                        </span>
                                                    </h4>
                                                </div>
                                            </header>
                                            <div className="btClear btSeparator bottomSmallSpaced noBorder">
                                                <hr />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="rowItem col-md-4 col-ms-12 btTextRight animate animate-fadein inherit animated"
                                        data-width={4}
                                    >
                                        <div className="rowItemContent">
                                            <a
                                                href="#"
                                                className="btBtn btBtn btnFilledStyle btnAccentColor btnMedium btnNormalWidth btnRightPosition btnNoIcon"
                                            >
                                                <span className="btnInnerText">CONTACT US</span>
                                            </a>
                                            <div className="btClear btSeparator bottomSmallSpaced noBorder">
                                                <hr />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}


            <section id=" bt_section6628b5ee8932a" data-parallax="0.8" data-parallax-offset="0" className=" abt11  boldSection topSpaced bottomSemiSpaced btDarkSkin btAlternateColorBackground gutter boxed inherit btParallax wBackground cover wBackground cover"
                style={{ backgroundImage: "url('https://industrial.bold-themes.com/blue-laboratory/wp-content/uploads/sites/11/2016/10/background_3.jpg')", backgroundPosition: '50% 75.6695px',marginBottom:"30px" }}>
                <div className="port">
                    <div className="boldCell">
                        <div className="boldCellInner" style={{marginTop:"10px"}}>
                            <div className="boldRow">
                                <div className="boldRowInner">
                                    <div className="rowItem col-md-6 col-sm-12 btTextLeft animate animate-fadein inherit animated" data-width="6">
                                        <div className="rowItemContent">
                                            <header className="header btClear large btDash bottomDash">
                                                <div className="btSuperTitle" ><span style={{fontSize:"30px"}}>Why Us...?</span></div>
                                                <div className="dash">
                                                    <h2><span className="headline">AutometEnigeering</span></h2>
                                                </div>
                                            </header>
                                        </div>
                                    </div>
                                    <div className="rowItem col-md-6 col-sm-12 btTextLeft animate animate-fadein inherit animated" data-width="6">
                                        <div className="rowItemContent"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="boldRow">
                                <div className="boldRowInner">
                                    <div className="rowItem col-md-6 col-sm-12 btTextLeft animate animate-fadein inherit animated" data-width="6">
                                        <div className="btText" style={{textAlign:"justify"}}>
                                            <ul className='why'>
                                                <li className="listItem">Autometa engineering optimizes industrial processes through automation, leading to increased efficiency and productivity.</li>
                                                <li className="listItem">It reduces operational costs by minimizing the need for manual labor and material wastage.</li>
                                                <li className="listItem">Enhances workplace safety by automating hazardous tasks and minimizing the risk of accidents.</li>
                                                <li className="listItem">Ensures consistent product quality by reducing human error and maintaining precise control over production parameters.</li>
                                                <li className="listItem">Enables scalability and adaptability to changing production demands, providing flexibility in response to market dynamics..</li>
                                            </ul>
                                        </div>

                                    </div>
                                    <div className="rowItem col-md-6 col-sm-12 btTextLeft animate animate-fadein inherit animated" data-width="6">
                                        <div className="rowItemContent">
                                            <header className="header btClear small">
                                                <div className="btSuperTitle"><span>VISION</span></div>
                                            </header>
                                            <div className="btProgressBar animate btProgressBarFilledStyle">
                                                <div className="btProgressContent">
                                                    <div data-percentage="100" className="btProgressAnim animate" style={{ transitionDelay: '169ms', transform: 'translateX(0%)' }}><span>100%</span></div>
                                                </div>
                                            </div>
                                            <div className="btClear btSeparator bottomSmallSpaced noBorder">
                                                <hr />
                                            </div>
                                            <header className="header btClear small">
                                                <div className="btSuperTitle"><span>PLAN</span></div>
                                            </header>
                                            <div className="btProgressBar animate btProgressBarFilledStyle">
                                                <div className="btProgressContent">
                                                    <div data-percentage="90" className="btProgressAnim animate" style={{ transitionDelay: '234ms', transform: 'translateX(-10%)' }}><span>90%</span></div>
                                                </div>
                                            </div>
                                            <div className="btClear btSeparator bottomSmallSpaced noBorder">
                                                <hr />
                                            </div>
                                            <header className="header btClear small">
                                                <div className="btSuperTitle"><span>GROWTH</span></div>
                                            </header>
                                            <div className="btProgressBar animate btProgressBarFilledStyle">
                                                <div className="btProgressContent">
                                                    <div data-percentage="80" className="btProgressAnim animate" style={{ transitionDelay: '103ms', transform: 'translateX(-20%)' }}><span>80%</span></div>
                                                </div>
                                            </div>
                                            <div className="btClear btSeparator bottomSemiSpaced noBorder">
                                                <hr />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <header class="header btClear large btDash bottomDash  " style={{ marginLeft: "170px" }}>
                <div class="dash crt1"><h2><span class="headline" style={{ color: "black" }}>Our Certificates</span>
                </h2>
                </div>

            </header>
            <section className='cert1 cee' style={{ display: "flex" }}>

                <figure class="snip1179 red">
                    <img src="./Images/cer1.jpg" alt="sample24" />
                    <figcaption>
                        <div><i class="ion-ios-star"></i></div>
                    </figcaption>
                    <a href="#"></a>
                </figure>



                <figure class="snip1179 blue ">
                    <img src="./Images/cert2.JPG" alt="sample26" />
                    <figcaption>
                        <div><i class="ion-ios-refresh"></i></div>
                    </figcaption>
                    <a href="#"></a>
                </figure>
             
                <figure class="snip1179 blue">
                    <img src="./Images/Bronze_page-0001.jpg" alt="sample26" />
                    <figcaption>
                        <div><i class="ion-ios-refresh"></i></div>
                    </figcaption>
                    <a href="#"></a>
                </figure>
            </section>


        </div>
    )
}

export default About
